import { Request } from '@/types/request';

export default {
  namespaced: true,
  state: {
    showModal: false,
    form: {
      dateStart: new Date().toISOString(),
      dateEnd: new Date().toISOString(),
      reason: '',
      leaveTypeId: 0,
      statusId: 0,
      userId: 1,
      id: null,
    } as Request,
  },
  mutations: {
    updateField(state: any, payload: object) {
      state.form = {
        ...state.form,
        ...payload,
      };
    },
    set(state: any, payload: Request) {
      state.form = payload;
    },
    show(state: any, payload: boolean) {
      state.showModal = payload;
    },
  },
  actions: {
    resetBuilder({ commit }: {commit: any}): void {
      commit('set', {
        dateStart: new Date().toISOString(),
        dateEnd: new Date().toISOString(),
        reason: '',
        leaveTypeId: 0,
        statusId: 0,
        userId: 1,
        id: null,
      } as Request);
      commit('show', false);
    },
    showModal({ commit }: {commit: any}, payload: any) {
      if (payload) {
        commit('set', payload);
      }
      commit('show', true);
    },
  },
  getters: {
    form: (state: any): Request => state.form,
    showModal: (state: any): boolean => state.showModal,
  },
};

